import { DivisorProps } from './types';

import * as S from './styles';

const Divisor: React.FC<DivisorProps> = props => (
  <S.Divisor data-testid="divisor" {...props} />
);

export default Divisor;
